import { createGetEndpoint } from '@sonar-software/sonar-http';
import { SonarObjectUser } from '@types';

export type GetSonarObjectUsersRequest = {
	sonarObjectId: number;
};

export type GetSonarObjectUsersResponse = Array<SonarObjectUser>;

export const getSonarObjectUsers = createGetEndpoint<GetSonarObjectUsersRequest, GetSonarObjectUsersResponse>(
	({ sonarObjectId }) => `/api/v3/core/sonar-objects/${sonarObjectId}/users`
);
